import axios from "../../../../utils/axios";

export const deleteOptimiseRxPatient = async (patientId: string) => {
  if (!patientId) return;

  return await axios.post("/clinical/prescription/gb/fdb/optimise-rx/delete-patient", {
    patientId,
  });
};

export const convertProspectiveToCurrent = async (patientId: string, conceptId: string) => {
  if (!patientId || !conceptId) return;

  return await axios.post("/clinical/prescription/gb/fdb/optimise-rx/convert", {
    patientId,
    conceptId,
  });
};

export const updateOptimiseRxProspectiveDrug = async (
  patientId: string,
  conceptId: string,
  issueQuantity: string | null,
) => {
  if (!patientId || !conceptId) return;

  return await axios
    .post("/clinical/prescription/gb/fdb/optimise-rx/prospective-drug", {
      patientId,
      conceptId,
      issueQuantity,
    })
    .then(() => {
      return getOptimiseRxResultSet(patientId, issueQuantity ? "Swap" : "Complex") ?? [];
    });
};

export const getOptimiseRxResultSet = async (patientId: string, type: string) => {
  if (!patientId) return;

  return await axios
    .get("/clinical/prescription/gb/fdb/optimise-rx/result-set", {
      params: {
        patientId,
        type,
      },
    })
    .then((res) => res.data.results);
};

export const acceptOptimiseRxProduct = async (patientId: string, ruleId: string) => {
  return await axios.post("/clinical/prescription/gb/fdb/optimise-rx/accept-rule", {
    patientId,
    ruleId,
  });
};

export const provisionOptimiseRxPatient = async (patientId: string) => {
  return await axios
    .post("/clinical/prescription/gb/fdb/optimise-rx/provision-patient", {
      patientId,
    })
    .then(async (res) => {
      return res.data?.optimiseRxUserId;
    });
};
